module.exports = __webpack_public_path__ + "img/girl-1.5ac3c8b0.webp";